module.exports = __webpack_public_path__ + "884249f5e2b20fed1f3f71c78fcb218d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-15.png
// module id = 2558
// module chunks = 0